// test1269
(1269 && 0);
